var GripMini = (function(options={}){
	// "use strict";
	
	var RESERVATION_ID = "reservationId";
	var CONTENT_ID = "contentId";
	var USER_CODE = "userCode";
	var SECTION_ID = "sectionId";
	var DISCOVER = "discover";
	var SERVICE_ID = "serviceId";
	var SESSION_KEY = "sessionKey";
	var PARENT_ID = "parentId";
	var SCROLL_PARENT_ID = "scrollParentId";
	var TYPE = "type";
	var RATIO = "ratio";
	var Z_INDEX = "z-index"; 
	var CONFIRM_CELLULAR = "confirmCellular";
	var VERSION ="version";
	var PATH = "path";
	var COUPONS = "coupons";
	var PRODUCT_COUNT = "productCount";
	var FLOATING = "floating";
	var OPTIONS = "options";
	var USE_SHARE = "useShare";
	var USE_CLOSE = "useClose";
	var USE_MUTED = "muted";
	var USE_FOLLOW = "useFollow";
	var FOLLOWED = "followed";
	var MESSAGE_COUNT = "messageCount";
	var EXCLUDE_NOTI = "excludeNoti";
	var THEME_ID = "themeId";
	var VALIDATE_PRODUCT = "validateProduct";
	var LANG = "lang";
	var UI = "ui";
	var TIP_LIST = "tipList";
	
	var _parentId;
	var _scrollParentId;
	var _parentEl;
	var _type = "float";
	var _domain = server_url;	// FIXME 이것을 dynamic 하게 셋팅해서 로드하도록 수정해줘야 한다.
	var _iframeEl = undefined;
	var _containerEl = undefined;
	var _iframeSize = {width:0,height:0};
	var _isWaiting = true;
	var _viewRatio = 3/4.0;
	var _zIndex = 100000;
	var _options = {};
	var _closeFloat = false;
	var _confirmCellular = false;
	var _version = "1";
	var _path = "r";
	var _productCount = 0;
	var _coupons = [];
	var _callbackMap = {};
	var _floatingInfo = {};
	var _floatingOptions = {};
	var _uiOptions = undefined;
	var _useFloatingClose = true;
	var _playHighFirst = true;
	var _validateProduct = false;
	var _tipList = [];
	
	function _init(options={}){
		if(_checkOptions(options) == false){
			alert("유효하지 않은 파라메터 입니다. 필수 값을 넣어주세요");
			return;
		}
		_options = options;
		_parentId = options[PARENT_ID];
		_scrollParentId = options[SCROLL_PARENT_ID];
		_uiOptions =  options[UI];
		_floatingInfo = options[FLOATING]|| {};
		_floatingOptions = _floatingInfo[OPTIONS] || {};
		_useFloatingClose = _floatingOptions[USE_CLOSE] == undefined ? true : _floatingOptions[USE_CLOSE];
		_type = _floatingInfo[TYPE] || options[TYPE];
		
		_viewRatio = options[RATIO];
		_zIndex = options[Z_INDEX];
		_confirmCellular = options[CONFIRM_CELLULAR] || false;
		_version = options[VERSION] || "1";
		_path = options[PATH] || "r";
		_coupons = options[COUPONS] || [];
		_productCount = options[PRODUCT_COUNT] || 0;
		_validateProduct = options[VALIDATE_PRODUCT] || false;
		_lang = options[LANG];
		_parentEl = document.getElementById(_parentId);
		_tipList = options[TIP_LIST];
		
		
		if(_uiOptions != undefined && _uiOptions["video"] != undefined && _uiOptions["video"]["playHighFirst"] != undefined){
			_playHighFirst = _uiOptions["video"]["playHighFirst"];
		}
		
		if(_parentEl == undefined){
			alert("유효하지 않은 element id 입니다.");
			return;
		}

		_attachEvent();
		
		_createIframeEl(_parentEl, options);
		
		_attachIFrameEvent();
		_onResize();
	}

	function _checkOptions(options){
		if(options[RESERVATION_ID] == undefined && options[CONTENT_ID] == undefined && options[USER_CODE] == undefined && options[SECTION_ID] == undefined && options[DISCOVER] == undefined && options[DISCOVER+"new"] == undefined){
			return false;
		}
		if(options[SERVICE_ID] == undefined){
			return false;
		}
		if(options[SESSION_KEY] == undefined){
			options[SESSION_KEY] = "";
		}
		
		options[PARENT_ID] = options[PARENT_ID] || "embed";
		options[TYPE] = options[TYPE] || "float";
		options[RATIO] = options[RATIO] || 3/4.0;
		options[Z_INDEX] = options[Z_INDEX] || 10000;
		
		return true;
	}
	
	function paramToString(params) { // url 에 params을 넣으면 get 용이라는 의미
		var str = "?" + Object.getOwnPropertyNames(params).map((key) => {
	        const value = params[key];
	        if(Array.isArray(value)){
	            return value.map((item) => {
	                return String(key)+ "=" + encodeURIComponent(item);
	            }).join("&");
	        }else{
	            return String(key)+ "=" + encodeURIComponent(params[key]);
	        }
	        
	    }).join("&");

        return str;
    }

	function _getParentDomain(){
		var domain = location.protocol + "//" + location.hostname;
		if(location.port){
			domain += ":" + location.port;
		}
		if(location.protocol == "file:"){
			domain = "*";
		}
		return domain;
	}

	function _createIframeEl(parentEl, options){
		var domain = _getParentDomain();
		
		var container = document.createElement('DIV');
		
// container.style = "opacity:1;width:100%;height:100%;";
		
		try{
			
		// alert(JSON.stringify(container));
			// container.style =
			// "opacity:1;width:100px;height:500px;background:red;";

			container.style["opacity"] = 1;
			container.style["width"] = "100%";
			container.style["height"] = "100%";
			
		}catch(e){
// alert(e.message);
		}
		
		
		 var iframe = document.createElement("IFRAME");
		 
// iframe.style = "opacity:1;width:100%;height:100%;background:blue;";
		 iframe.style["opacity"] = 1;
		 iframe.style["width"] = "100%";
		 iframe.style["height"] = "100%";
		 
		 iframe.allow = "autoplay";
		 iframe.frameBorder = "0";

		 if(options[SECTION_ID] != undefined || options[DISCOVER] == true || options[DISCOVER+"new"] == true){
			 // iframe.scrolling = "yes";
		 }else{
			 iframe.scrolling = "no";
		 }
		 
		 
		 var decodedSessionKey = decodeURIComponent(options[SESSION_KEY]);

		 var  params =  {
				 serviceId : options[SERVICE_ID],
				 sessionKey : decodedSessionKey,
				 domain : domain,
				 v : _version,
		 };
		 
		 if(_productCount > 0){
			 params["productCount"]  = _productCount;
		 }
		 
		 if(_confirmCellular){
			 params["cellular"] = true;
		 }
		 if(_useFloatingClose == false){	// false만 유의미하도록 수정
			 params["fClose"] = false;
		 }
		 if(options[USE_SHARE] == false){
			 params["share"]  = false;
		 }
		 if(options[USE_CLOSE]){
			 params["close"]  = options[USE_CLOSE];
		 }
		 if(options[USE_MUTED] == false){
			 params["muted"]  = false;
		 }
		 
		 if(options[USE_FOLLOW]){
			 params["follow"]  = options[USE_FOLLOW];
		 }
		 if(options[FOLLOWED]){
			 params["followed"]  = options[FOLLOWED];
		 }
		 
		 if(options[THEME_ID]){
			 params["themeId"]  = options[THEME_ID];
		 }

		if (options[UI] && options[UI].screenType !== undefined) {
			params["screenType"] = options[UI].screenType
		}
		 
		 if(options[MESSAGE_COUNT]){
			 params["msgCnt"] = Math.min(options[MESSAGE_COUNT], 500); 
		 }
		 if(options[EXCLUDE_NOTI]){
			 if(options[EXCLUDE_NOTI] instanceof Array){
				 params["exNoti"] = options[EXCLUDE_NOTI]; 	 
			 }else{
				 params["exNoti"] = [options[EXCLUDE_NOTI]];
			 }
		 }
 		 if(_playHighFirst == false) {
		 	 params["playHighFirst"]  = false;
		 }

 		 if(_validateProduct){
 			 params["validateProduct"] = true;
 		 }
 		 
 		 if(_lang) {
 		 	params["lang"] = _lang;
		 }

		 var queryString = paramToString(params);
		 
		 if(options[RESERVATION_ID] != undefined && options[RESERVATION_ID].length > 0){
			 iframe.src = _domain + "/embed/r/2/" + options[RESERVATION_ID] +  queryString;
		 }else if(options[DISCOVER] == true){
			 if(options[CONTENT_ID] != undefined && options[CONTENT_ID].length > 0){
				 params["redirectContentId"] = options[CONTENT_ID];
				 queryString = paramToString(params);
			 }
			 iframe.src = _domain + "/embed/discover" + queryString;
		 }else if(options[DISCOVER+"new"] == true){
			if(options[CONTENT_ID] != undefined && options[CONTENT_ID].length > 0){
				params["redirectContentId"] = options[CONTENT_ID];
				queryString = paramToString(params);
			}
			iframe.src = _domain + "/embed/discover/new" + queryString;
		}else if(options[SECTION_ID] != undefined){
			 if(options[CONTENT_ID] != undefined && options[CONTENT_ID].length > 0){
				 params["redirectContentId"] = options[CONTENT_ID];
				 queryString = paramToString(params);
			 }
			 iframe.src = _domain + "/embed/section/" + options[SECTION_ID] +  queryString;	 
		 }else if(options[CONTENT_ID] != undefined && options[CONTENT_ID].length > 0){
			 iframe.src = _domain + "/embed/" + options[CONTENT_ID] +  queryString;	 
		 }else{
			 iframe.src = _domain + "/embed/u/" + options[USER_CODE] +  queryString;
		 }
		 
		 
		 
		 container.appendChild(iframe);
		 parentEl.appendChild(container);
		 _iframeEl = iframe;
		 _containerEl = container;
	}
	
	function _attachIFrameEvent(){
		if(_iframeEl){
			_iframeEl.addEventListener("load",_onloadIframe, true);
			_checkPageTimeoutError();
		}
	}
	function _attachEvent(){
		window.removeEventListener("message", _onPostMessage);
		window.addEventListener("message", _onPostMessage, false);
		window.removeEventListener("resize", _onResize);
		window.addEventListener("resize", _onResize, false);
		
		if(_scrollParentId){
			var scrollParentEl = document.getElementById(_scrollParentId);
			scrollParentEl.addEventListener("scroll", _onScroll, false);
		}else{
			document.addEventListener("scroll", _onScroll, false);	
		}
	}
	

	var _iframeValidateTimer = undefined;
	var _iframeLoadTimeoutTimer = undefined;
	
	function _clearErrorTimer(){
		if(_iframeValidateTimer){
			clearTimeout(_iframeValidateTimer);
			_iframeValidateTimer = undefined;
		}
		
		if(_iframeLoadTimeoutTimer){
			clearTimeout(_iframeLoadTimeoutTimer);
			_iframeLoadTimeoutTimer = undefined;
		}
	}
	
	function _checkPageTimeoutError(){
		if(_iframeLoadTimeoutTimer){
			clearTimeout(_iframeLoadTimeoutTimer);
			_iframeLoadTimeoutTimer = undefined;
		}
		_iframeLoadTimeoutTimer = setTimeout(function() {
			if(_callbackMap["error"] != undefined){
				_clearErrorTimer();
				_callbackMap["error"]({
					code : 500,
					message : "10초 내에 로드되지 못했습니다."
				});
			}
		}, 10000);
		
	}
	
	// 로드된 상태에서 페이지에 요청을 해 응답이 올때까지 기다리는
	function _checkPageValidationByOnload(){
		if(_iframeValidateTimer){
			clearTimeout(_iframeValidateTimer);
			_iframeValidateTimer = undefined;
		}
		
		_iframeValidateTimer = setTimeout(function() {
			if(_callbackMap["error"] != undefined){
				_clearErrorTimer();
				_callbackMap["error"]({
					code : 500,
					message : "오류가 발생했습니다."
				});
			}
		}, 300);
		_sendMessage("ping");
	}
	

	function wrapResult(success, data){
		return {
			success : success,
			passedData : data
		}
	}

	var focusScrollPosition = undefined;

	function _onPostMessage(evt) {
		if(evt.origin !== _domain){
			log("invalid post message ",evt, evt.origin , _domain);
			return;
		}
		
		if(evt.data.type == "pong") {
			_clearErrorTimer();
			if(_uiOptions){
				_sendMessage("updateUIOptions", _uiOptions);
			}

		}else if(evt.data.type == "keydown"){
			if(_callbackMap["keydown"] != undefined){ 
				_callbackMap["keydown"](evt.data);
			}
		}else if(evt.data.type == "focus"){
			if(focusScrollPosition == undefined){
				focusScrollPosition = document.documentElement.scrollTop || document.body.scrollTop;	
			}
		}else if(evt.data.type == "blur"){
			if(focusScrollPosition != undefined){
				_scrollTo(focusScrollPosition, 300);	
			}
			focusScrollPosition = undefined;
		}else if(evt.data.type == "play"){
			_isWaiting = false; 
			_recalculateViewSize();
			callback("play", evt.data);
		}else if(evt.data.type == "resize"){
			_onResize();
		}else if(evt.data.type == "coupon"){
			
			if(_callbackMap["coupon"] == undefined){	// 콜백 없음
				_sendMessage("coupon", wrapResult(false,evt.data));
			}else{	// 콜백 있음
				var result = _callbackMap["coupon"](evt.data);
				
				if(result != undefined){
					_sendMessage("coupon", wrapResult(result,evt.data));
				}else{	// skip for async response

				}
			}
			
		}else if(evt.data.type == "scrollto-top"){
			var irect = _parentEl.getBoundingClientRect();
			_parentEl.scrollIntoView();
// _scrollTo(_parentEl.scrollTop, 1000);
		}else if(evt.data.type == "close-float"){
			_closeFloat = true;
			_onScroll();
		}else if(evt.data.type == "needLogin"){
			_sendMessage("needLogin", wrapResult(callback("needLogin", evt.data), evt.data));
		}else if(evt.data.type == "fullscreen-on") {
			if ((window.fullScreen) || (window.innerWidth == screen.width && window.innerHeight == screen.height)) {
				// $(".main-container")[0].requestFullscreen();
				document.exitFullscreen();
			} else {
				var iframe = parent.document.getElementsByTagName("iframe")[0];
			    fullscreenOn(iframe);
			}
		}else if(evt.data.type == "fullscreen-off") {
			fullscreenOff();
		}else if(evt.data.type == "share"){
			if (callback("share", evt.data)) {
			}else{
				// alert(evt.data.data.url);
				_sendMessage("processShare",{});	// callback이 없는경우 자식에게 다시
													// 공유하기를 전달한다.
			}
		}else if(evt.data.type == "close"){
			_sendMessage("close", wrapResult(callback("close", evt.data),evt.data));
		}else if(evt.data.type == "playend"){
			if (callback("playend", evt.data)) {
			}
		}else if(evt.data.type == "follow"){
			if (callback("follow", evt.data)) {
			}
		}else if(evt.data.type == "unfollow"){
			if (callback("unfollow", evt.data)) {
			}
		}else if(evt.data.type == "tag"){
			callback("tag", evt.data);
		} else if(evt.data.type == "joinLive"){	// 라이브에 진입 성공
			// UI정보도 같이 전달
			if(_uiOptions){
				_sendMessage("updateUIOptions", _uiOptions);
			}
			
			// 이때 쿠폰 정보가 존재한다면 coupon 정보를 전달해준다.
			if(_coupons && _coupons.length > 0){	// 쿠폰 정보가 존재한다면
				_sendMessage("updateCoupon", _coupons);
			}

			if(_tipList && _tipList.length > 0) {
				_sendMessage("tipList", _tipList);
			}
		} else if(evt.data.type == "endLive"){	// 라이브 종료
			
		} else if(evt.data.type == "requestProductList"){	// 상품 목록 요청
			// return을 통해 처리된 경우
			//콜백이 있는데 undefined라면 사용안함 처리...
			try {
				if(typeof _callbackMap["productList"] !== "undefined") {
					var callbackResult = _callbackMap["productList"](evt.data);

					if(typeof callbackResult === "undefined") {
						return;
					}
				}
			} catch(err) {
				console.error(err);
				// 오류만 표시하고, 기존동작대로 처리...
			}

			// 기존 동작대로
			var productList = callback("productList") ;

			_sendMessage("requestProductList", wrapResult(productList, evt.data));
			_sendMessage("productList", productList);
		} else if(evt.data.type == "validateProductList"){	// 상품 목록 요청
			_sendMessage("validateProductList", wrapResult(callback("validateProductList", evt.data), evt.data));	// 해당
		} else if(evt.data.type == "product"){	// 상품 클릭
			_sendMessage("product", wrapResult(callback("product", evt.data),evt.data));
		}else if(evt.data.type == "cart"){	// 카트 클릭
			_sendMessage("cart", wrapResult(callback("cart", evt.data),evt.data));
		}else if(evt.data.type == "confirmCellular"){
			callback("confirmCellular", evt.data);
		}else if(evt.data.type == "openProfile"){	// 카트 클릭
			_sendMessage("openProfile", wrapResult(callback("openProfile", evt.data), evt.data));
		}else if(evt.data.type == "getUIOptions"){	// ui옵션을 요청하면 받는다.
			if(_uiOptions){
				_sendMessage("updateUIOptions", wrapResult(false, _uiOptions));
			}
		}else if(evt.data.type == "clickLink"){	// 카트 클릭
			_sendMessage("clickLink", wrapResult(callback("clickLink", evt.data),evt.data));
		}else if(evt.data.type == "banner"){	// 배너 클릭
			_sendMessage("banner", wrapResult(callback("banner", evt.data),evt.data));
		}else if(evt.data.type == "content"){	// 컨텐츠 클릭
			_sendMessage("content", wrapResult(callback("content", evt.data),evt.data));
		} else if(evt.data.type == "couponBox") {
			_sendMessage("couponBox", wrapResult(callback("couponBox", evt.data), evt.data));
		} else if(evt.data.type == "activatedProduct") {
			_sendMessage("activatedProduct", wrapResult(callback("activatedProduct", evt.data), evt.data));
		} else if(evt.data.type == "noticeLink") {
			callback("noticeLink", evt.data);
		}  else if(evt.data.type == "liveInfoMore") {
			callback("liveInfoMore", evt.data);
		}  else if(evt.data.type == "liveInfoClose") {
			callback("liveInfoClose", evt.data);
		}  else if(evt.data.type == "requestTipList") {
			var tipList = callback("tipList") ;
			_sendMessage("requestTipList", wrapResult(tipList, evt.data));	// 해당
			_sendMessage("tipList", tipList);
		}  else  if(evt.data.type == "tipClose") {
			callback("tipClose", evt.data);
		}  else if(evt.data.type == "tipImageLink"){
			_sendMessage("tipImageLink", wrapResult(callback("tipImageLink", evt.data), evt.data));
		}  else if(evt.data.type == "reservationPush") {
			const result = _callbackMap["reservationPush"](evt.data);

			if (result == undefined) {
				return;
			}

			_sendMessage("reservationPush", wrapResult(result, evt.data));
		} else if(evt.data.type == "loaded") {
			_sendMessage("loaded", wrapResult(callback("loaded", evt.data), evt.data));
		} else {	// 미구현된 콜백들은 호출해보고 응답 주도록 변경
			_sendMessage(evt.data.type, wrapResult(callback(evt.data.type, evt.data), evt.data));
		}
		
	}
	
	function fullscreenOn(iframe) {
		if (iframe.requestFullscreen) {
		  iframe.requestFullscreen();
		} else if (iframe.webkitRequestFullscreen) {
		  iframe.webkitRequestFullscreen();
		} else if (iframe.mozRequestFullScreen) {
		  iframe.mozRequestFullScreen();
		} else if (iframe.msRequestFullscreen) {
		  iframe.msRequestFullscreen();
		}
	}
	
	function fullscreenOff() {
		if (document.exitFullscreen) {
		    document.exitFullscreen();					
		} else if (document.msExitFullscreen) {
		    document.msExitFullscreen();
		} else if (document.mozCancelFullScreen) {
		    document.mozCancelFullScreen();
		} else if (document.webkitCancelFullScreen) {
		    document.webkitCancelFullScreen();
		}
	}
	
	function applyToStyle(el, params){
		if(params){
			el.style = "";
			Object.getOwnPropertyNames(params).map((key) => {
				const value = params[key];
				el.style[key] = value;
			});
        }
	}
	function mapToStyle(params){
		var result = "";
		if(params){
			result =  Object.getOwnPropertyNames(params).map((key) => {
				const value = params[key];
				return String(key)+ ":" + encodeURIComponent(params[key]);
			}).join(";");
        }
		return result;
	}
	var _state = "visible";
	var _height = 0;
	var _floatMiniStyle = undefined;
	var _floatIframeStyle = undefined;
	var _floatTopStyle = undefined;
	function _onScroll(evt){
		var offsetY = 0;
		if(_scrollParentId){
			var scrollParentEl = document.getElementById(_scrollParentId);
			var scrollParentRect = scrollParentEl.getBoundingClientRect();
			offsetY = scrollParentRect.y;
		}
		var rect = _parentEl.getBoundingClientRect();
		var irect = _iframeEl.getBoundingClientRect();
		
		var height = Math.max(_height, irect.height);
		_height = height;
		var width = irect.width;
		var visibleHeight =  rect.y + height;

		if(_height == 0 || _isWaiting){	// 유효하지 않은 element 이거나 대기상태라면
			return;
		} 
		var topHeight = 200;
		if(_type == "top"){
			topHeight = _floatingOptions["height"] || 200;
		}
		
		if( _type == "top" && visibleHeight < topHeight + offsetY){
			_state = "bottomVisible";
		}else  if(visibleHeight < offsetY){
			_state = "invisible";
		}else{
			_state = "visible";
			_closeFloat = false;
		}

		if(!_closeFloat && _type == "float" && _state == "invisible" ){
			// _state = "invisible";
			// 하단의 floating view로 만들준다.
			var w = 100;
			var h = 150;
			
			if(_floatMiniStyle == undefined){
				var data = {
						position : "fixed",
						width : (_floatingOptions["width"] || 100) + "px",
						height : (_floatingOptions["height"] || 150) + "px",
						right : (_floatingOptions["right"] || 10) +"px",
						bottom: (_floatingOptions["bottom"] || 30) +"px",
						"border-radius" : "5px",
						overflow : "hidden",
						"z-index" : _floatingOptions["z-index"] || _zIndex
				}
				_floatMiniStyle = data;
			}
			
			if(_floatIframeStyle == undefined){
				var data = {
						width : (_floatingOptions["width"] || 100) + "px",
						height : (_floatingOptions["height"] || 150) + "px",
						"border-radius" : "5px",
						"-webkit-border-radius" : "5px",
				}
				_floatIframeStyle = data;
			}
			applyToStyle(_containerEl, _floatMiniStyle);
			applyToStyle(_iframeEl, _floatIframeStyle);
			
		}else if(_type == "top"  &&  _state == "bottomVisible" ){
			var top = -(height - topHeight) + offsetY;
			
			var floatTopStyle = {
					position : "fixed",
					width : width + "px",
					height : height + "px",
					top : (_floatingOptions["top"] || top) +"px",
					left: (_floatingOptions["left"] || 0) +"px",
					"z-index" : _zIndex,
					"clip-path" : "inset("+(offsetY - top)+"px 0 0 0)"
					
			};
			
			// _state = "bottomVisible";
			
			applyToStyle(_containerEl, floatTopStyle);
			applyToStyle(_iframeEl, {width:"100%", height:"100%"});
		}else{
			// _state = "visible";
			
			var fullStyle = {	
							width:"100%", 
							height:"100%",  
							"z-index":_zIndex
						};
			applyToStyle(_containerEl, fullStyle);
			_matchIframeSize();
		}
	}
	function _onloadIframe(evt){
		var irect = _iframeEl.getBoundingClientRect();
		_iframeSize = {width:irect.width, height:irect.height};
		_checkPageValidationByOnload();
	}
	function _sendMessage(type,data){
		if(_iframeEl){
			try{
				var passObj = {
						type : type,
						data : data
					};
				
				_iframeEl.contentWindow.postMessage(passObj, _domain);	
			}catch(e){
				log(e);
			}
			
		}
	}
	function _onResize(){
		_matchIframeSize();
// _recalculateViewSize();
		
	}
	function _recalculateViewSize(){
		var rect = _parentEl.getBoundingClientRect();
		var target = _parentEl;
		var height = rect.width / _viewRatio;
		if(rect.height != height){
// _parentEl.style =
// "width:"+rect.width+"px;height:"+height+"px;overflow:hidden;z-index:10000;";
		}
	}
	function _matchIframeSize(){
		var rect = _parentEl.getBoundingClientRect();
		
		applyToStyle(_iframeEl, {
			width : "100%",
			height : "100%",
			overflow : "hidden",
			"z-index" :_zIndex
		});
		// _iframeEl.style =
		// "width:"+rect.width+"px;height:"+rect.height+"px;overflow:hidden;z-index:10000;";
	}
	function _scrollTo(to = 0, duration= 1000) {
	    const start = document.documentElement.scrollTop || document.body.scrollTop;
	    const change = to - start;
	    const increment = 20;
	    let currentTime = 0;

	    const animateScroll = (() => {

	      currentTime += increment;

	      const val = Math.easeInOutQuad(currentTime, start, change, duration);

	      document.documentElement.scrollTop = document.body.scrollTop = val;

	      if (currentTime < duration) {
	        setTimeout(animateScroll, increment);
	      }
	    });

	    animateScroll();
  	}

	  Math.easeInOutQuad = function (t, b, c, d) {

	    t /= d/2;
	    if (t < 1) return c/2*t*t + b;
	    t--;
	    return -c/2 * (t*(t-2) - 1) + b;
	  };
	  
	  function log(...args){
		  if(_debug){
			  console.log(args);  
			  // console.trace();
		  }
	  }


	function callback(type, data){
		try {
			var typeCallback = _callbackMap[type];
			if(typeCallback){
				return typeCallback(data) || false;
			}
		}catch(e){
			
		}
		return false;
	}
	function on(type, callback){
		if(type && callback){
			_callbackMap[type] = callback;
		}else{
			// invalid callback
		}
		
		return this;
	}
	
	function pause(){
		_sendMessage("pause");
	}
	
	function resume(){
		_sendMessage("resume");
	}
	
	function destroy() {
		try{
			
			if(_scrollParentId){
				var scrollParentEl = document.getElementById(_scrollParentId);
				scrollParentEl.removeEventListener("scroll", _onScroll, false);
			}else{
				document.removeEventListener("scroll", _onScroll, false);	
			}
			
		}catch(e){
			
		}
		
		try{
			window.removeEventListener("message", _onPostMessage, false);
		}catch(e){
			
		}
		
		try{
			if(_iframeEl){
				_iframeEl.removeEventListener("load",_onloadIframe, true);
				_iframeEl.src = "about:blank";
			}	
		}catch(e){
			
		}
		
		_clearErrorTimer();
	}

	function updateCouponBoxCount(couponBoxCount) {
		_sendMessage("updateCouponBoxCount", wrapResult(true, couponBoxCount));
	}

	function setCurrentTime(duration) {
		  _sendMessage("setCurrentTime", wrapResult(true, duration));
	}

	function sendCouponResult(result, couponInfo) {
		_sendMessage("coupon", wrapResult(result, couponInfo));
	}

	function sendProductList(productList, productInfo) {
		_sendMessage("requestProductList", wrapResult(productList, productInfo));
		_sendMessage("productList", productList);
	}

	function mute(mute) {
		_sendMessage("mute", wrapResult(true, mute));
	}

	function pipMode(pip) {
	  	_sendMessage("pipMode", wrapResult(true, pip));
	}

	function sendReservationPushResult(result, reservationPushInfo) {
		  _sendMessage("reservationPush", wrapResult(result, reservationPushInfo));
	}

	_init(options);

	return {
		// 이곳에서 외부에서 사용가능한 play, stop, 등등을 제공할 수 있다.
		on : on,
		pause : pause,
		resume : resume,
		destroy : destroy,
		sendCouponResult : sendCouponResult,
		sendProductList: sendProductList,
		updateCouponBoxCount: updateCouponBoxCount,
		setCurrentTime: setCurrentTime,
		mute: mute,
		pipMode: pipMode,
		sendReservationPushResult: sendReservationPushResult
	};
});